export const imageMapping: { [key: string]: string } = {
  "Consomé": "consome.jpg",
  "Consomé con Yema": "consome-huevo.jpg",
  "Sopa de Cocido": "sopa-cocido.jpg",
  "Crep de Farinato": "Crep de Farinato.jpeg",
  "Plato del Día": "",
  "Gazpacho (Temporada)": "gazpacho.jpeg",
  "Entremeses": "",
  "Guisantes con Jamón": "guisantes-con-jamon.jpg",
  "Alcachofas con Jamón": "alcachofas-con-jamon.jpg",
  "Revuelto de Gambas": "revuleto-gambas.jpg",
  "Revuelto de Champiñones y Gambas": "revuelto-champinones.jpg",
  "Revuelto de Trigueros y Gambas": "revuelto-trigueros-con-gambas.jpg",
  "Morcilla de Arroz con pimientos": "",
  "Ensalada Normal": "ensalada.jpg",
  "Ensalada Mixta": "ensalada-mixta.jpg",
  "Ensalada de Naranja": "ensalada-de-naranja.jpg",
  "Ensalada de Frutos de Secos con Rulo de Cabra": "ensalada-frutos-secos.jpg",
  "Ensalada de Tomate con Queso Mozarella": "large-2931846.jpg",
  "Espárragos Blancos": "esparragos.jpg",
  "Ración de Queso Curado": "racion-queso.jpg",
  "Ración de Chorizo Ibérico": "racion-chorizo-iberico.jpg",
  "Ración de Salchichón Ibérico": "racion-salchichon.jpg",
  "Ración de Lomo Ibérico": "racion-lomo.jpg",
  "Tabla Surtido de Ibéricos": "",
  "Ración de Pan": "large-2068220.jpg",
  "Ternera a la Plancha con Patatas": "ternera-plancha.jpg",
  "Escalope de Ternera con Patatas": "escalope-ternera.jpg",
  "Lomo de Cerdo con Patatas": "lomo-cerdo.jpg",
  "Pechuga de Pollo a la Plancha con Patatas": "pechuga-plancha.jpg",
  "Escalope de Pollo con Patatas": "escalope-de-pollo.jpg",
  "Chuletillas de Cordero con Patatas": "chuletillas-de-cordero.jpg",
  "Entrecot con Patatas": "entrecot.jpg",
  "Chuletón con Patatas y Pimientos": "chuleton.jpg",
  "Callos con Chorizo": "callos.jpg",
  "Morros de Ternera Rebozados": "morro-rebozado.jpg",
  "Calamares a la Romana": "calamares.jpg",
  "Sepia a la Plancha": "sepia-a-la-plancha.jpg",
  "Pescado del Día": "",
  "Gambas al Ajillo": "gambas-al-ajillo.jpg",
  "Nº1. Huevos con Farinato y Patatas": "huevos-con-farinato.jpg",
  "Nº2. Huevos con Bacon y Patatas": "huevos-con-bacon-y-patatas.jpg",
  "Nº3. Huevos con Chorizo y Patatas": "huevos-con-chorizo.jpg",
  "Nº4. Huevos con Jamón y Patatas": "huevos-con-jamon.jpg",
  "Nº5. Lomo, Bacon, Huevo y Patatas": "lomo,-bacon,-huevos-y-patatas.jpg",
  "Nº6. Lomo, Tortilla, Espárragos y Patatas": "",
  "Nº7. Pechuga, Huevo, Bacon y Patatas": "pollo-bacon-huevo.jpg",
  "Nº8. Ternera, Huevo, Bacon y Patatas": "ternera-huevo-patatas.jpg",
  "Nº9. Escalope de Ternera, Huevo y Patatas": "escalope-ternera.jpg",
  "Nº10. Tortilla Francesa, Calamares y Patatas": "tortilla-atun.jpg",
  "Nº11. Tortilla Francesa con Patatas": "tortlla-francesa-y-patatas.jpg",
  "Nº12. Tortilla Francesa con Jamón y Patatas": "tortilla-jamon.jpg",
  "Nº13. Tortilla Francesa con Atún y Patatas": "tortilla-atun.jpg",
  "Nº14. Huevos con Patatas": "huevos-con-patatas.jpg",
  "Nº15. Sándwich Mixto": "sandwich.jpg",
  "Nº16. Sándwich de la Casa": "sandwich-vegetal.jpg",
  // Nuevos mapeos para la carta actualizada
  "Chuletón de Morucha": "chuleton.jpg",
  "Entrecot de Morucha": "entrecot.jpg",
  "Pechuga de Pollo a la Plancha": "pechuga-plancha.jpg",
  "Escalope de Pollo": "escalope-de-pollo.jpg",
  "Huevos Rotos con Jamón": "huevos-con-jamon.jpg",
  "Huevos Rotos con Chorizo": "huevos-con-chorizo.jpg",
  "Ensalada de Queso de Cabra": "ensalada-frutos-secos.jpg",
  "Revuelto de Espárragos": "revuelto-trigueros-con-gambas.jpg",
  "Tabla de Quesos": "racion-queso.jpg",
  "Queso Manchego": "racion-queso.jpg",
  "Queso de Cabra": "racion-queso.jpg",
  "Solomillo Ibérico a la Plancha": "racion-lomo.jpg", // Aproximación
  "Secreto Ibérico": "racion-lomo.jpg", // Aproximación
  "Pluma Ibérica": "racion-lomo.jpg", // Aproximación
  "Presa Ibérica": "racion-lomo.jpg", // Aproximación
};
